module.exports = __webpack_public_path__ + "img/hr-V-L-4-unload-standup-shadow.8d9463f9.png";